import {createContext, RefObject, useContext} from "react";

export const ContentContainerContext = createContext<RefObject<HTMLElement | null> | null>(null);

export const useContentContainerRef = (): RefObject<HTMLElement | null> | null =>
	useContext(ContentContainerContext);
